export function defaultFollowUpTitle(leadTitle: string): string {
  const trimmed = leadTitle.trim();
  return trimmed.length > 0 ? `Follow up: ${trimmed}` : 'Follow up';
}
